import store from '@/store';

export default (to, from, next) => {
    const is_sim_disable_enable_allowed = store.getters.is_sim_disable_enable_allowed;

    return {
        allow: is_sim_disable_enable_allowed,
        redirect: { name: 'not-found' },
    }
};
